{
  "chat": {
    "title": "Czat",
    "empty": "Brak czatów",
    "loadError": "Nie udało się załadować tej rozmowy",
    "messagePlaceholder": "Wiadomość",
    "typing": "{{name}} pisze…",
    "typingTwo": "{{a}} i {{b}} piszą…",
    "typingMany": "Kilka osób pisze…",
    "online": "Online",
    "offline": "Offline",
    "unread": "Nieprzeczytane",
    "startDm": "Napisz do {{name}}",
    "members": "Członkowie",
    "mute": "Wycisz tę rozmowę",
    "unmute": "Wyłącz wyciszenie tej rozmowy",
    "muted": "Wyciszona"
  },
  "login": {
    "title": "Witaj ponownie!",
    "description": "Wpisz swój adres email, a wyślemy Ci kod do logowania.",
    "input": {
      "label": "Adres email",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Wyślij kod",
      "loading": "Wysyłanie kodu..."
    }
  },
  "verify": {
    "title": "Wpisz kod",
    "description": "Wpisz kod, który wysłaliśmy na adres {{email}}.",
    "input": {
      "label": "Kod weryfikacyjny",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Zweryfikuj kod",
      "loading": "Weryfikacja kodu..."
    },
    "buttonAbort": {
      "label": "Anuluj"
    },
    "buttonResend": {
      "label": "Wyślij ponownie"
    },
    "error": {
      "Invalid or expired OTP.": "Kod wygasł lub jest nieprawidłowy.",
      "invalidOtp": "Kod wygasł lub jest nieprawidłowy."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Wyloguj się",
      "confirmTitle": "Wylogowanie",
      "confirmMessage": "Czy na pewno chcesz się wylogować?",
      "error": "Wylogowanie nie powiodło się. Spróbuj ponownie."
    }
  },
  "errors": {
    "types": {
      "authentication": "Błąd uwierzytelniania",
      "network": "Problem z połączeniem",
      "generic": "Coś poszło nie tak"
    },
    "messages": {
      "sessionExpired": "Twoja sesja wygasła. Zaloguj się ponownie.",
      "networkError": "Sprawdź swoje połączenie internetowe i spróbuj ponownie.",
      "genericError": "Wystąpił nieoczekiwany błąd. Możesz spróbować odświeżyć stronę lub się wylogować.",
      "noOrg": "Nie znaleziono organizacji..."
    },
    "technical": {
      "title": "Szczegóły techniczne:",
      "retryAttempts": "Próby: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Spróbuj ponownie",
      "loginAgain": "Zaloguj się ponownie",
      "logout": "Wyloguj się",
      "moreOptions": "Więcej opcji",
      "chooseAction": "Wybierz działanie:",
      "refreshApp": "Odśwież aplikację",
      "debugData": "Dane debugowania",
      "clearCacheRetry": "Wyczyść pamięć podręczną i ponów"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Ładowanie...",
    "cancel": "Anuluj",
    "confirm": "Potwierdź",
    "error": "Błąd",
    "success": "Sukces",
    "time": {
      "dayAgo": "1 dzień temu",
      "daysAgo": "{{count}} dni temu",
      "weekAgo": "1 tydzień temu",
      "weeksAgo": "{{count}} tygodni temu",
      "monthsAgo": "{{count}} miesięcy temu",
      "secondsAbbr": "s"
    },
    "profile": "Profil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Nie znaleziono organizacji"
    },
    "quickActions": {
      "media": {
        "title": "Wszystkie media",
        "subtitle": "Przeglądaj bibliotekę"
      },
      "achievements": {
        "title": "Osiągnięcia",
        "subtitle": "Zobacz postępy"
      },
      "profile": {
        "title": "Karta członkowska",
        "subtitle": "Twoje dane"
      },
      "membership": {
        "title": "Członkostwo",
        "subtitle": "Zobacz plan"
      },
      "offers": {
        "title": "Oferty",
        "subtitle": "Przeglądaj dostępne"
      },
      "invite": {
        "title": "Zaproś członków",
        "subtitle": "Utwórz kod QR"
      }
    },
    "sections": {
      "featuredVideos": "Polecane filmy",
      "lastViewed": "Ostatnio oglądane",
      "bookmarkedVideos": "Zapisane elementy",
      "recentAchievements": "Ostatnie osiągnięcia",
      "viewAllAction": "Pokaż wszystko"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Wymagana konfiguracja płatności",
      "subtitle": "Twoje członkostwo zostało przeniesione do tej organizacji. Aby kontynuować, skonfiguruj płatność za pomocą jednej z dostępnych metod płatności.",
      "paidUntilNote": "Opłacony okres zostaje zachowany — nie zostaniesz obciążony przed {{date}}.",
      "bonusOffer_one": "Skonfiguruj płatność do {{date}}, a otrzymasz {{count}} miesiąc gratis.",
      "bonusOffer_few": "Skonfiguruj płatność do {{date}}, a otrzymasz {{count}} miesiące gratis.",
      "bonusOffer_many": "Skonfiguruj płatność do {{date}}, a otrzymasz {{count}} miesięcy gratis.",
      "bonusOffer_other": "Skonfiguruj płatność do {{date}}, a otrzymasz {{count}} miesiąca gratis.",
      "openDashboard": "Skonfiguruj płatność w panelu internetowym",
      "openDashboardHint": "Ze względów bezpieczeństwa konfiguracja płatności odbywa się w przeglądarce. Zalogowanie nastąpi automatycznie.",
      "checkAgain": "Płatność została zakończona",
      "error": "Nie udało się rozpocząć konfiguracji płatności. Spróbuj ponownie."
    },
    "title": "Członkostwo",
    "status": {
      "active": "Aktywne",
      "inactive": "Nieaktywne"
    },
    "period": {
      "monthly": "Miesięczny",
      "yearly": "Roczny"
    },
    "pricing": {
      "per": {
        "monthly": "miesięcznie",
        "yearly": "rocznie"
      }
    },
    "sections": {
      "planDetails": "Szczegóły",
      "organization": "Organizacja"
    },
    "labels": {
      "billingPeriod": "Okres rozliczeniowy",
      "memberSince": "Członek od",
      "validUntil": "Ważne do",
      "cancelled": "Subskrypcja anulowana"
    },
    "organization": {
      "memberDescription": "Jesteś członkiem tej organizacji"
    },
    "management": {
      "title": "Zarządzaj swoją subskrypcją",
      "description": "Aby wprowadzić zmiany w subskrypcji, skorzystaj z aplikacji webowej OctaHub lub skontaktuj się bezpośrednio z {{organizationName}}."
    },
    "dashboard": {
      "title": "Otwórz panel",
      "subtitle": "Zarządzaj subskrypcją i ustawieniami",
      "openError": "Nie udało się otworzyć panelu. Spróbuj ponownie."
    }
  },
  "media": {
    "download": {
      "button": "Pobierz",
      "available": "Dostępne offline"
    },
    "screens": {
      "bookmarks": "Zapisane filmy",
      "lastViewed": "Ostatnio oglądane filmy",
      "library": "Media"
    },
    "bookmark": {
      "save": "Zapisz",
      "saved": "Zapisano",
      "bookmarkLabel": "Zakładka",
      "bookmarkedLabel": "Zapisano"
    },
    "folder": {
      "itemCount_one": "{{count}} element",
      "itemCount_other": "{{count}} elementów",
      "folderDescription": "Folder z {{count}} elementami"
    },
    "sharedFolders": {
      "upload": "Prześlij",
      "newFolder": "Nowy folder",
      "folderNamePlaceholder": "Nazwa folderu...",
      "uploading": "Przesyłanie...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "Plik przesłano pomyślnie",
      "uploadError": "Przesyłanie nie powiodło się",
      "uploadErrorMessage": "Wystąpił błąd podczas przesyłania. Spróbuj ponownie.",
      "uploadSubtitle": "Prześlij plik do tego folderu",
      "newFolderSubtitle": "Utwórz nowy podfolder"
    },
    "navigation": {
      "previous": "Poprzedni",
      "next": "Następny"
    },
    "relatedVideos": "Powiązane treści",
    "delete": {
      "button": "Usuń",
      "confirmTitle": "Usuń media",
      "confirmMessage": "Czy na pewno chcesz usunąć ten element? Tej operacji nie można cofnąć.",
      "success": "Media usunięto pomyślnie",
      "error": "Usuwanie nie powiodło się",
      "errorMessage": "Nie udało się usunąć tego elementu. Spróbuj ponownie.",
      "errorInUse": "Ten element jest używany w jednej lub więcej ofertach i nie może zostać usunięty."
    }
  },
  "achievements": {
    "title": "Osiągnięcia",
    "subtitle": "Twoje zdobyte osiągnięcia",
    "count_zero": "Brak osiągnięć",
    "count_one": "{{count}} osiągnięcie zdobyte",
    "count_other": "{{count}} osiągnięć zdobytych",
    "earned": "Zdobyto {{time}}",
    "emptyState": {
      "title": "Brak osiągnięć",
      "description": "Ukończ kursy i aktywności, aby zdobyć swoje pierwsze osiągnięcie!"
    }
  },
  "noOrg": {
    "title": "Nie znaleziono organizacji",
    "description": "Nie masz jeszcze dostępu do żadnej organizacji. Skontaktuj się z administratorem, aby uzyskać dostęp, lub sprawdź ponownie później.",
    "actions": {
      "title": "Co możesz zrobić:",
      "contactAdmin": "Skontaktuj się z administratorem organizacji",
      "askInvitation": "Poproś o zaproszenie",
      "checkAccount": "Sprawdź, czy używasz właściwego konta",
      "tryRelogin": "Spróbuj się wylogować i zalogować ponownie"
    }
  },
  "offers": {
    "title": "Oferty",
    "detailsTitle": "Szczegóły oferty",
    "notFound": "Nie znaleziono oferty",
    "notFoundMessage": "Tej oferty nie udało się znaleźć",
    "noOffers": "Brak dostępnych ofert w tej chwili",
    "purchased": "Zakupiono",
    "free": "Bezpłatnie",
    "purchaseWebOnly": "Zakup tylko w aplikacji webowej",
    "claimOffer": "Odbierz ofertę",
    "purchase": "Kup",
    "purchasedBadge": "✓ Już posiadasz tę ofertę",
    "youOwnThis": "Masz dostęp do wszystkich treści w tej ofercie",
    "missingAchievements": "⚠️ Nie masz wymaganych osiągnięć do tej oferty. Brakuje Ci jeszcze: {{missing}}",
    "mobileNotAvailable": "⚠️ Zakupy nie są dostępne w aplikacji mobilnej",
    "mobileNotAvailableSubtext": "Odwiedź naszą stronę internetową, aby kupić tę ofertę",
    "price": "Cena:",
    "includedContent": "Zawarte treści",
    "includedAchievements": "Zawarte osiągnięcia",
    "videoCount_one": "{{count}} film",
    "videoCount_other": "{{count}} filmów",
    "audioCount_one": "{{count}} audio",
    "audioCount_other": "{{count}} audio",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDF",
    "documentCount_one": "{{count}} dokument",
    "documentCount_other": "{{count}} dokumentów",
    "imageCount_one": "{{count}} obraz",
    "imageCount_other": "{{count}} obrazów",
    "achievementCount_one": "{{count}} osiągnięcie",
    "achievementCount_other": "{{count}} osiągnięć",
    "paymentDenied": {
      "title": "Płatność niedostępna",
      "description": "Ta oferta nie jest dostępna do zakupu w Twoim regionie"
    },
    "pricing": {
      "netAmount": "Kwota netto"
    },
    "errors": {
      "general": "Błąd",
      "purchaseFailed": "Przetwarzanie zakupu nie powiodło się",
      "webOnly": "Zakupy są dostępne tylko w wersji webowej"
    },
    "success": {
      "claimed": "Oferta odebrana pomyślnie!"
    },
    "paymentProviders": {
      "selectTitle": "Wybierz metodę płatności",
      "selectSubtitle": "Wybierz sposób płatności",
      "stripe": {
        "name": "Stripe",
        "description": "Karta kredytowa, karta debetowa, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Saldo PayPal, karta kredytowa, konto bankowe"
      }
    },
    "payment": {
      "processing": "Przetwarzanie płatności...",
      "success": {
        "title": "Płatność zakończona sukcesem!",
        "message": "Twój zakup został pomyślnie zrealizowany. Masz teraz dostęp do treści.",
        "viewOffer": "Zobacz ofertę",
        "backToOffers": "Powrót do ofert"
      },
      "pending": {
        "title": "Płatność w toku",
        "message": "Twoja płatność jest nadal przetwarzana. Może to potrwać chwilę...",
        "checkStatus": "Sprawdź status"
      },
      "failed": {
        "title": "Płatność nie powiodła się",
        "message": "Twoja płatność nie mogła zostać zrealizowana. Spróbuj ponownie.",
        "tryAgain": "Spróbuj ponownie"
      }
    }
  },
  "orgSelection": {
    "title": "Wybierz organizację",
    "subtitle": "Wybierz organizację, aby kontynuować",
    "switchOrg": "Zmień organizację",
    "switchOrgSubtitle": "Przejdź do innej organizacji",
    "currentOrg": "Bieżąca"
  },
  "profile": {
    "myPurchases": "Moje zakupy",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Język",
      "subtitle": "Wybierz preferowany język",
      "systemDefault": "Domyślny systemowy"
    },
    "notifications": {
      "title": "Powiadomienia",
      "subtitle": "Wybierz, o czym chcesz być powiadamiany",
      "chat": "Wiadomości na czacie",
      "chatHint": "Otrzymuj powiadomienia o nowych wiadomościach w Twoich rozmowach",
      "seeAll": "Zobacz wszystkie powiadomienia",
      "permissionDenied": "Powiadomienia dla tej aplikacji są wyłączone w ustawieniach urządzenia."
    }
  },
  "openWebApp": "Otwórz Web App",
  "openWebAppSubtext": "Zarządzaj swoim kontem, zakupami i nie tylko na {{url}}",
  "openWebAppError": "Nie udało się otworzyć aplikacji webowej. Spróbuj ponownie.",
  "invite": {
    "title": "Zaproś członków",
    "selectPlan": "Wybierz plan członkostwa",
    "selectGroup": "Wybierz grupę",
    "generating": "Generowanie...",
    "scanToJoin": "Zeskanuj ten kod QR, aby dołączyć",
    "createAnother": "Utwórz kolejny",
    "error": {
      "createFailed": "Nie udało się utworzyć zaproszenia. Spróbuj ponownie.",
      "noPlans": "Brak dostępnych planów członkostwa."
    }
  },
  "notifications": {
    "title": "Powiadomienia",
    "empty": "Brak powiadomień",
    "markAllRead": "Oznacz wszystkie jako przeczytane",
    "unread": "Nieprzeczytane",
    "loadError": "Nie udało się załadować powiadomień",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nowa wiadomość"
    }
  }
}
